module.exports = __webpack_public_path__ + "img/nolist.b600b743.gif";